<template>
  <b-container v-if="errors && errors.length > 0" class="error">
    <b-row v-for="(error, errorIndex) of errors" :key="errorIndex">
      <span v-if="error == 'required'">
        {{ $t("label_evaluation_thisFieldMandatory_warning") }}
      </span>
      <span v-if="error == 'requiredArr'">
        {{ $t("label_evaluation_makeSelection_warning") }}
      </span>
      <span v-if="error == 'float'">
        {{ $t("label_evaluation_numericFieldMandatory_warning") }}
      </span>
      <span v-if="error == 'email'"> Enter a valid email </span>
      <span v-if="error == 'duplicated'">
        This value is duplicated in the database. Please change this value.
      </span>
      <span v-if="error == 'repeated'"> Value cannot be repeated </span>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "FormError",
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    fieldName: {
      default: "",
    },
  },
};
</script>

<style lang="sass" scoped>
.error
  font-size: 12px
  color: #ff0000
</style>
